import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateExerciseCreate = {
  exerciseCreate: { data: null, loading: false, error: null },
};

export const exerciseCreate = createAsyncThunk('user/exerciseCreate', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .post(`/exercise/create`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerExerciseCreate = {
  [exerciseCreate.pending]: (state) => {
    state.exerciseCreate.loading = true;
  },
  [exerciseCreate.fulfilled]: (state, action) => {
    state.exerciseCreate.loading = false;
    state.exerciseCreate.data = action.payload;
    state.exerciseCreate.error = null;
  },
  [exerciseCreate.rejected]: (state, action) => {
    state.exerciseCreate.data = null;
    state.exerciseCreate.loading = false;
    state.exerciseCreate.error = action.payload;
  },
};
